import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../../../infrastructure/handlers/populate-data-handler";
import {SideBarModuleTabClickHandler} from "./side-bar-module.tab-click.handler";

export class SideBarModuleHandlers extends HandlerList {
  static injectables = [
    TimingHandler,
    PopulateDataHandler,
    SideBarModuleTabClickHandler
  ];

  constructor(
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler,
    sideBarModuleTabClickHandler: SideBarModuleTabClickHandler
  ) {
    super();

    [
      timingHandler,
      populateDataHandler,
      sideBarModuleTabClickHandler
    ].forEach(handler => this.add(handler));
  }
}
